// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SessionOperations } from '../Enums/Constants';
export class TradeSessionStatus {
    constructor(msg) {
        this.Id = msg.Id;
        this.Name = '';
        this.AllowedOrderTypes = null;
        this.AllowedTIFs = null;
        this.AllowedOperations = SessionOperations.None;
        this.IsDecreaseOnlyPositionCount = false;
        this.update(msg);
    }
    update(msg) {
        if (isNullOrUndefined(msg)) {
            return;
        }
        this.Name = msg.Name;
        this.IsDecreaseOnlyPositionCount = msg.IsDecreaseOnlyPositionCount;
        this.AllowedOperations = msg.AllowedOperations;
        this.AllowedOrderTypes = msg.AllowedOrderTypes;
        this.AllowedTIFs = msg.AllowedTIFs;
    }
}
// #endregion TradeSessionStatus
